import { useState, useEffect } from 'react';
import { fetchCollectionItemsProxy, transformWebflowData, transformServicesData, transformCitiesData } from '../services/webflowAPI';
import { getServiceConfigsFromData } from '../utils/serviceConfig';

export const useWebflowData = (collectionId, serviceType = null) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [serviceConfigs, setServiceConfigs] = useState({});

  useEffect(() => {
    const loadData = async () => {
      if (!collectionId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        console.error('[DEBUG] useWebflowData: Loading collectionId:', collectionId);
        const items = await fetchCollectionItemsProxy(collectionId);
        console.error('[DEBUG] useWebflowData: Received items:', items?.length || 0);
        const transformed = transformWebflowData(items);
        console.error('[DEBUG] useWebflowData: Transformed items:', transformed.length);
        
        // Detectar configuraciones de servicios dinámicamente
        const configs = getServiceConfigsFromData(transformed);
        setServiceConfigs(configs);
        
        // Filtrar por tipo de servicio si se especifica
        let filtered = transformed;
        if (serviceType) {
          const normalizedServiceType = serviceType.toLowerCase().trim();
          filtered = transformed.filter(item => {
            const itemService = item.service?.toLowerCase().trim();
            return itemService === normalizedServiceType;
          });
        }
        
        console.error('[DEBUG] useWebflowData: Final filtered items:', filtered.length);
        setData(filtered);
      } catch (err) {
        console.error('Error loading Webflow data:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [collectionId, serviceType]);

  return { data, loading, error, serviceConfigs };
};

export const useWebflowServices = (collectionId) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadServices = async () => {
      if (!collectionId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const items = await fetchCollectionItemsProxy(collectionId);
        const transformed = transformServicesData(items);
        setServices(transformed);
      } catch (err) {
        console.error('Error loading Webflow services:', err);
        setError(err);
        setServices([]);
      } finally {
        setLoading(false);
      }
    };

    loadServices();
  }, [collectionId]);

  return { services, loading, error };
};

export const useWebflowCities = (collectionId) => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCities = async () => {
      if (!collectionId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const items = await fetchCollectionItemsProxy(collectionId);
        const transformed = transformCitiesData(items);
        setCities(transformed);
      } catch (err) {
        console.error('Error loading Webflow cities:', err);
        setError(err);
        setCities([]);
      } finally {
        setLoading(false);
      }
    };

    loadCities();
  }, [collectionId]);

  return { cities, loading, error };
};

